exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ../core-js/library/modules/_object-gops.js
// module id = 420
// module chunks = 25